const domready = require('../helpers/domready');
const events = require('../core/events');
const forgeUiComponent = require('../framework/ui-component');

const DonationPrompt = forgeUiComponent('DonationPrompt', {
  donating: 'is-donating',
  designated: 'is-designated'
}, function DonationPromptConstructor() {
  const self = this;
  const designationElement = this.element.querySelector('.DonationPrompt-designation') || document.createElement('div');

  Object.defineProperty(this, 'showDesignation', {
    get: function getDesignation() {
      const mainContent = document.querySelector('main');
      const mainDesignation = mainContent && mainContent.getAttribute('data-donation-show-designation');
      return mainDesignation || this.element.getAttribute('data-show-designation');
    }
  });

  Object.defineProperty(this, 'djDesignation', {
    get: function getDesignation() {
      const mainContent = document.querySelector('main');
      const mainDesignation = mainContent && mainContent.getAttribute('data-donation-dj-designation');
      return mainDesignation || this.element.getAttribute('data-dj-designation');
    }
  });

  Object.defineProperty(this, 'designationText', {
    get: function getDesignation() {
      return designationElement.textContent || '';
    },
    set: function setDesignation(text) {
      if (text) {
        designationElement.textContent = text;
        this.designated = true;
      } else {
        this.designated = false;
      }
    }
  });

  document.addEventListener(events.uiWantsDonation, function () {
    self.updateDesignation();
    self.donating = true;
  });

  this.element.addEventListener(events.uiModalDismiss, function () {
    self.donating = false;
    if (document.location.hash === '#support' || document.location.hash === '#monthly-support') {
      document.location.hash = '';
    }
  });

  domready(function checkForSupportFragment() {
    if (document.location.hash === '#support' || document.location.hash === '#monthly-support') {
      document.dispatchEvent(new CustomEvent(events.uiWantsDonation, { bubbles: true }));
    }
  });
});

DonationPrompt.prototype.updateDesignation = function updateDesignationText() {
  this.designationText = this.showDesignation || this.djDesignation || false;
};

module.exports = DonationPrompt;



//////////////////
// WEBPACK FOOTER
// ./src/js/ui/donation-prompt.js
// module id = 53
// module chunks = 0